import { Td, Flex, Checkbox } from "@chakra-ui/react";
import { useResource } from "hooks/resources/providers/resourceProvider";

type TdCheckboxProps = {
	entity: unknown;
};

export function TdCheckbox({ entity }: TdCheckboxProps) {
	const { selection } = useResource<unknown>();

	function handleSelectItem(e: React.ChangeEvent<HTMLInputElement>) {
		e.stopPropagation();
		selection.handleSelectItem(entity, e.target.checked);
	}

	return (
		<Td onClick={(e) => e.stopPropagation()}>
			<Flex justifyContent="center">
				<Checkbox
					colorScheme="teal"
					isChecked={selection.isSelectedItem(entity)}
					onChange={handleSelectItem}
					onClick={(e) => e.stopPropagation()}
				/>
			</Flex>
		</Td>
	);
}
